module.exports = new __parcel__URL__("sw.js").toString();